"use strict";

exports.__esModule = true;
exports.default = {
  handleClick: function handleClick(e) {
    e.stopPropagation();
  }
};